<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="1667.000000pt" height="1667.000000pt" viewBox="0 0 1667.000000 1667.000000"
 preserveAspectRatio="xMidYMid meet">
<metadata>
Created by potrace 1.14, written by Peter Selinger 2001-2017
</metadata>
<g transform="translate(0.000000,1667.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M2108 16655 c-454 -62 -866 -240 -1223 -528 -102 -82 -303 -288 -381
-392 -229 -301 -386 -640 -459 -992 -48 -232 -45 126 -45 -6408 0 -6622 -4
-6179 51 -6435 30 -137 111 -375 174 -507 285 -600 797 -1057 1422 -1268 120
-41 225 -67 388 -98 l110 -21 6120 -3 c6695 -4 6231 -8 6504 53 351 77 700
244 993 474 106 83 295 272 378 378 230 293 397 642 474 993 61 273 57 -191
53 6504 l-3 6120 -21 110 c-31 163 -57 268 -98 388 -297 879 -1068 1511 -1988
1632 -105 13 -778 15 -6235 14 -5021 -1 -6134 -3 -6214 -14z m11944 -1635
c455 -43 819 -355 941 -805 l22 -80 3 -5750 c2 -4234 0 -5771 -8 -5830 -65
-454 -441 -830 -895 -895 -59 -8 -1596 -10 -5830 -8 l-5750 3 -80 22 c-453
123 -765 490 -805 947 -13 151 -13 11270 0 11421 5 61 19 146 30 190 26 101
114 280 179 366 178 234 456 390 743 418 127 13 11321 13 11450 1z"/>
<path d="M11941 14490 c-140 -30 -282 -96 -411 -194 -120 -91 -5371 -5347
-5430 -5435 -61 -92 -116 -215 -142 -317 -32 -127 -32 -351 0 -479 27 -109
103 -267 171 -355 27 -36 1246 -1260 2708 -2721 2769 -2767 2703 -2703 2868
-2786 190 -96 435 -122 641 -69 230 60 454 223 588 428 113 173 159 328 159
528 0 186 -42 332 -144 500 -48 78 -231 265 -2363 2397 l-2311 2313 2296 2297
c1806 1808 2307 2315 2348 2376 123 181 175 345 174 547 0 201 -46 355 -157
525 -130 199 -322 344 -556 420 -75 25 -103 28 -240 31 -85 2 -175 -1 -199 -6z"/>
<path d="M4973 5690 c-615 -65 -1124 -460 -1296 -1006 -52 -163 -62 -241 -62
-484 0 -199 3 -237 23 -329 135 -601 589 -1057 1183 -1187 119 -27 476 -27
599 -1 609 128 1080 597 1201 1196 41 203 36 512 -13 711 -135 553 -610 983
-1200 1084 -111 20 -328 27 -435 16z"/>
</g>
</svg>
